import { render, staticRenderFns } from "./WageSupplement.TypeConfiguration.Overview.vue?vue&type=template&id=81517ab0&scoped=true"
import script from "./WageSupplement.TypeConfiguration.Overview.vue?vue&type=script&lang=js"
export * from "./WageSupplement.TypeConfiguration.Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81517ab0",
  null
  
)

export default component.exports